import clsx from "clsx"

import type { TagProps } from "./types"

type TagClassArgs = Pick<TagProps, "className" | "bgColor"> & {
  size: NonNullable<TagProps["size"]>
}

export const tagClasses = ({ size, bgColor, className }: TagClassArgs): string => {
  return clsx(
    {
      neutral: "bg-neutral-200",
      primary: "bg-primary-200",
      lilac: "bg-lilac-200",
      green: "bg-green-200",
      red: "bg-red-200",
      yellow: "bg-yellow-200",
      orange: "bg-orange-700",
      lightGrey: "bg-neutral-200",
    }[bgColor],
    `flex w-fit flex-row content-center items-center justify-center self-start rounded-3xl px-2`,
    size === "small" && "h-[20px] text-[10px] uppercase",
    size === "large" && "h-6 text-[14px] leading-3",
    {
      "text-white": bgColor === "orange",
      "text-neutral-700": bgColor === "lightGrey",
      "text-neutral-900": bgColor !== "orange" && bgColor !== "lightGrey",
    },
    className,
  )
}
